import { LocaleEnum } from '@systemeio/ui-frontend'
import { useRouter } from 'next/router'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'

const NavLink = ({
  href,
  children,
  noLoco,
  signInLink,
}: {
  href: string
  children: string | JSX.Element
  noLoco?: boolean
  signInLink?: boolean
}) => {
  const router = useRouter()
  const locale = router.locale as LocaleEnum
  return (
    <LinkWithoutPrefetch
      locale={noLoco ? false : locale}
      className={`main-transition-colors w-fit whitespace-nowrap font-mulish outline-none ${
        signInLink
          ? 'text-brand-primary hover:text-brand-primary-hover focus-visible:text-brand-primary-hover'
          : 'text-text-secondary hover:text-brand-primary-hover focus-visible:text-brand-primary-hover'
      }`}
      href={href}
    >
      {children}
    </LinkWithoutPrefetch>
  )
}
export default NavLink
